import { createContext, useContext } from 'react'
import { SocialWebPopularPostsWidget } from 'schemas/SocialWebPopularPostsWidgetSchema'

interface WidgetContext {
  widgetSetting: SocialWebPopularPostsWidget
}

const widgetContext = createContext<Partial<WidgetContext>>({})
export default widgetContext

export const useWidgetContext = () => useContext(widgetContext) as WidgetContext
